import OnlineAppComponent from "../lib/online_app_component";
import {OnlineAppRootConfig} from "./online_app_root/online_app_root";

export const OnlineAppMapOverlayConfig = {
    baseHtmlClass: 'online_app__main__map_overlay',
    selector: '.online_app__main__map_overlay'
}

export class OnlineAppMapOverlay extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppMapOverlayConfig);
        if (!this.element) {
            return
        }

        this.messageElement = OnlineAppComponent.createElement('online_app__main__map_overlay__message');
        this.element.appendChild(this.messageElement);

        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
        this.dispatchAction('mapOverlaySelected');
    }

    // The overlay is active when in modal or oversize modal mode *and* the nav is open.
    isActive() {
        return (this.isNavOpen() && this.isModalMode()) || this.isNoMapFilter();
    }

    render() {
        this.conditionallySetHtmlClassState(this.isActive(), 'active');
        const message = this.getMessage();
        this.messageElement.innerHTML = !!message ? message : '';
        setTimeout(()=>{
            const horizSpace = (!!this.onlineApp.nav) ? this.onlineApp.nav.getHorizSpace() : 0;
            this.element.style.paddingLeft = `${ horizSpace }px`;
        },500)
    }

    getMessage() {
        if (this.isStillLoadingResources()) return null;
        if (this.isModalMode() && this.isNavOpen()) return null;
        if (this.isNoMapFilter()) return "<p>No map content</p>";
    }

    isStillLoadingResources() {
        return !this.readStateMachineValue('everythingLoaded');
    }

    isNavOpen() {
        return !!this.readState('navOpen');
    }

    isModalMode() {
        const modeCode = this.readStateMachineValue('modal');
        return (modeCode === OnlineAppRootConfig.modalModeCode) || (modeCode === OnlineAppRootConfig.oversizeModalModeCode);
    }

    isNoMapFilter() {
        const mapFilter = this.readStateMachineValue('mapFilter');
        return !mapFilter;
    }
}

export function getMapOverlay(parentElement, onlineApp) {
    if (!parentElement) return null;
    const element = OnlineAppComponent.createElement(
        OnlineAppMapOverlayConfig.baseHtmlClass,
    );
    parentElement.appendChild(element);
    return new OnlineAppMapOverlay(element, onlineApp);
}